import {StyleDeclaration, StyleSheet, css} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import {HighImpactChange} from 'config-migration/MigrationConstants';
import {schemaFieldsetName} from 'schemas/schema-interface/util/schemaFieldsetName';
import {ORANGE, RED} from 'ui-library/Colors';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import {capwords} from 'util/NameUtil';

import PopoverIcon from '../../ui-library/PopoverIcon';

const iconColorStyles = StyleSheet.create({
  HighImpactChangeIconRed: {
    color: RED,
  },
  HighImpactChangeIconOrange: {
    color: ORANGE,
  },
});
const styles = StyleSheet.create({
  highImpactChangeIcon: {
    width: 12,
    height: 12,
    marginRight: 6,
  },
});

interface IconInfo {
  iconName: string;
  description: string;
  iconColor: StyleDeclaration;
}

const CHANGE_TO_ICON_MAPPING = new Map<HighImpactChange, IconInfo>([
  [
    HighImpactChange.REQUIRED,
    {
      iconName: 'asterisk',
      description: 'Field marked as "required"',
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
  [
    HighImpactChange.NOT_REQUIRED,
    {
      iconName: 'asterisk',
      description: 'Field marked as "not required"',
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
  [
    HighImpactChange.ARCHIVED,
    {
      iconName: 'box-archive-arrow-down',
      description: 'Field marked as "archived"',
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
  [
    HighImpactChange.NOT_ARCHIVED,
    {
      iconName: 'box-archive-arrow-down',
      description: 'Field marked as "not archived"',
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
  [
    HighImpactChange.DROPDOWN_UPDATE,
    {
      iconName: 'basic_folder_item',
      description: 'Dropdown updates affect existing data',
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
  [
    HighImpactChange.FIELDSET,
    {
      iconName: 'basic_folder_item',
      description: `System ${capwords(schemaFieldsetName())} updates can affect existing data`,
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
  [
    HighImpactChange.REMOVED,
    {
      iconName: 'trash-can',
      description: 'Field removed from the interface',
      iconColor: iconColorStyles.HighImpactChangeIconRed,
    },
  ],
  [
    HighImpactChange.UNIT_SYMBOL_UPDATE,
    {
      iconName: 'pen-to-square',
      description: 'Unit symbol changed - may affect interpretability',
      iconColor: iconColorStyles.HighImpactChangeIconOrange,
    },
  ],
]);

export interface HighImpactChangeIconProps {
  highImpactChange: HighImpactChange;
}

export function HighImpactChangeIcon(props: HighImpactChangeIconProps): JSX.Element {
  const iconInfo = CHANGE_TO_ICON_MAPPING.get(props.highImpactChange);

  if (iconInfo) {
    return (
      <PopoverIcon
        renderContent={() => iconInfo.description}
        icon={iconInfo.iconName as BenchlingIconName}
        className={classNames({[css(styles.highImpactChangeIcon)]: true, [css(iconInfo.iconColor)]: true})}
      />
    );
  }
  // This shouldn't be possible since all high impact changes should have an associated Icon
  return <></>;
}
